import { defineStore } from 'pinia'

export default defineStore({
  id: 'bookingDataTable',
  persist: true,
  state: () => {
    return {
      columnState: [],
      isBookingArchive: false
    }
  },
  actions: {
    setColumnBookingState: function (payload: any) {
      this.columnState = payload
    },
    setIsBookingArchive: function (payload: boolean) {
      this.isBookingArchive = payload
    }
  },
  getters: {
    getColumnBookingState: (state: any) => state.columnState,
    getIsBookingArchive: (state: any) => state.isBookingArchive
  }
})
